<template>
  <generic-modal :title="$t('instance')" ref="generic_modal" size="fullscreen">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('select deployment')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/ngine/deployment/catalog"
              :display_function="
                (itm) => {
                  return itm.name + ' (' + itm.version + ')';
                }
              "
              value_field="deployment_id"
              @selected="set_deployment"
              ref="deployment_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("start event") }}</label>
            <div class="control">
              <div class="select">
                <select @change="start_event_selected">
                  <option
                    v-for="(start_event, idx) in start_events"
                    :key="idx"
                    :value="start_event.id"
                  >
                    {{ start_event.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="component_wrapper"></div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  success_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { createApp } from "vue/dist/vue.esm-bundler.js";
import mitt from "mitt";
const emitter = mitt();

export default {
  name: "InstanceModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      deployment: {},
      error: "",
      dynamic_component: null,
    };
  },
  computed: {
    start_events() {
      let v = this;
      if (
        v.deployment &&
        v.deployment.settings &&
        v.deployment.settings.process &&
        v.deployment.settings.process.components
      ) {
        let start_events = v.deployment.settings.process.components.filter(
          (component) => component.$type === "bpmn:StartEvent"
        );
        start_events.unshift({ id: null, name: "" });

        return start_events;
      } else return [];
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.$refs.deployment_dropdown.clear();
      if (v.dynamic_component && v.dynamic_component.unmount) {
        v.dynamic_component.unmount();
      }
      v.error = "";
    },
    set_deployment(deployment) {
      let v = this;
      if (deployment && deployment.uuid) {
        get("/ngine/deployment", { uuid: deployment.uuid })
          .then((response) => {
            // v.meta.deployment_uuid = deployment.uuid;
            v.deployment = response;
          })
          .catch((error) => {
            error_message(error);
          });
      }
    },
    start_event_selected(event) {
      let v = this;
      let event_id = event.target.value;
      if (event_id) {
        let target = v.deployment.settings.process.components.find(
          (component) => component.id === event_id
        );
        if (target && target.settings && target.settings.human_task_id) {
          if (v.deployment.settings.human_tasks) {
            let target_human_task = v.deployment.settings.human_tasks.find(
              (human_task) =>
                human_task.human_task_id == target.settings.human_task_id
            );
            if (target_human_task) {
              let code = target_human_task.settings.code;
              if (code && code.html && code.js && code.css)
                v.create_dynamic_component(
                  code.html,
                  code.js,
                  code.css,
                  target
                );
            } else {
              console.log("no target_human_task");
            }
          } else {
            console.log("no human_tasks");
          }
        } else {
          console.log("no human_task_id");
        }
      }
      // v.meta.start_event_id = event.target.value;
    },
    create_dynamic_component(html, js, css, target_component) {
      try {
        if (this.dynamic_component && this.dynamic_component.unmount)
          this.dynamic_component.unmount();

        // Evaluar el código JavaScript en un contexto de función
        const script = new Function(
          "return " + js.replace("export default", "")
        )();

        let opts = {
          ...script,
          template: html,
        };

        // Insertar CSS en el documento
        // const styleElement = document.createElement("style");
        // styleElement.innerHTML = css;
        // document.head.appendChild(styleElement);

        let app = createApp(opts);
        app.config.globalProperties.emitter = emitter;
        emitter.on("*", (type, e) => {
          if (type === "submit") {
            this.perform_submit(e, target_component);
          }
        });
        app.mount("#component_wrapper");
        this.dynamic_component = app;
      } catch (error) {
        console.error(error);
        this.error = generate_error_message_text(error);
      }
    },
    perform_submit(data, target_component) {
      let v = this;
      post("/ngine/workspace/instance/start", {
        deployment_uuid: v.deployment.uuid,
        start_event_id: target_component.id,
        data: data,
      })
        .then((response) => {
          success_message(v.$t("instance started"));
          v.close_modal();
          // console.log("response", response);
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
